export default __webpack_public_path__ + "static/media/down_arrow.f8333df3.svg";